import React, { Component } from 'react';
import { Link } from "react-router-dom";

import config from './../config';
import TermView from './TermView';
import SearchResultsDictionaryOverview from './SearchResultsDictionaryOverview';
import SearchResultsLanguageOverview from './SearchResultsLanguageOverview';
import CollapsibleCard from './CollapsibleCard';
import TermIndexList from './TermIndexList';
import DictionaryInfo from './DictionaryInfo';
import SearchSuggestion from './SearchSuggestion';
import ElementNotificationMessage from './../utils/ElementNotificationMessage';
//import localLibrary from './../utils/LocalLibrary';

import _ from 'lodash';

class SearchResultsList extends Component {
	constructor(props) {
		super(props);

		this.url = config.apiRoot+'/api/es/terms/';

		this.state = {
			listData: [],
			fetching: true
		};

		if (localStorage.getItem('ordabanki-list-style') == 'expanded') {
			this.state.expandAll = true;
		}
	}

	componentDidMount() {
		this.fetchData();
	}

	componentDidUpdate(prevProps, prevState) {
		// Skoðað hvort breytur hafa breyst og hvort component eigi að uppfærast
		if (
			prevProps.match.params.searchString != this.props.match.params.searchString ||
			prevProps.match.params.ordabok != this.props.match.params.ordabok ||
			prevProps.match.params.order != this.props.match.params.order ||
			prevProps.match.params.page != this.props.match.params.page
		) {
			this.fetchData();
		}
	}

	fetchData() {
		// Sæki gögn til APA
		this.setState({
			searchString: this.props.match.params.searchString,
			ordabok: this.props.match.params.ordabok,
			listData: [],
			fetching: true,
		});

		let urlParams = [];
		if (this.props.match.params.searchString) {
			urlParams.push('ord='+this.props.match.params.searchString);
		}
		if (this.props.match.params.ordabok) {
			urlParams.push('ordabok='+this.props.match.params.ordabok : '');
		}
		if (this.props.match.params.order && this.props.match.params.order != 'IS') {
			urlParams.push('sortlang='+this.props.match.params.order : '');
		}
		if (this.props.match.params.page) {
			urlParams.push('offset='+((this.props.match.params.page-1)*config.pageSize) : '');
		}

		fetch(this.url+'?'+urlParams.join('&'))
			.then(function(response) {
				return response.json();
			})
			.then(function(json) {
				this.setState({
					listData: json.results,
					prevUrl: json.previous || null,
					nextUrl: json.next || null,
					total: json.metadata.total,
					fetching: false
				})
			}.bind(this));

		if (this.props.onSearch) {
			console.log(this.props.match.params)
			this.props.onSearch(this.props.match.params);
		}
	}

	render() {
		let paginationUrl = '/leit/'+(this.props.match.params.searchString || '')+(this.props.match.params.ordabok ? '/ordabok/'+this.props.match.params.ordabok : '')+
			(this.props.match.params.order ? '/order/'+this.props.match.params.order : '');

		let currentPage = this.props.match.params.page || 1;

		let paginationLinks;
		
		if (
			((this.props.match.params.page*config.pageSize)-config.pageSize < this.state.total && this.props.match.params.page > 1) ||
			(currentPage*config.pageSize < this.state.total)
		) {
			paginationLinks = <React.Fragment>
				{
					(currentPage*config.pageSize)-config.pageSize < this.state.total && this.props.match.params.page > 1 &&
					<div className="page-item">
						<Link className="page-link" to={paginationUrl+(this.props.match.params.page ? '/page/'+(parseInt(this.props.match.params.page)-1) : '')} aria-label="Previous">
							<span aria-hidden="true">&laquo; Fyrri síða</span>
							<span className="sr-only">Fyrri síða</span>
						</Link>
					</div>
				}
				{
					(currentPage*config.pageSize < this.state.total) &&
					<div className="page-item">
						<Link className="page-link" to={paginationUrl+(this.props.match.params.page ? '/page/'+(parseInt(this.props.match.params.page)+1) : '/page/2')} aria-label="Next">
							<span aria-hidden="true">Næsta síða &raquo;</span>
							<span className="sr-only">Næsta síða</span>
						</Link>
					</div>
				}
			</React.Fragment>;
		}

		let termsStartIndex;
		let termsIndexId;

		if (this.state.listData.length > 0 && this.state.listData[0].words && this.state.listData[0].words[0]) {
			let order = this.props.match.params.order || 'IS';

			let word = _.find(this.state.listData[0].words, function(word) {
				return word.fklanguage == order;
			}.bind(this));

			if (word) {
				termsStartIndex = word.rownum-20;

				termsIndexId = this.state.listData[0].id;
			}
		}

		return (
			<div className="row">
				<div className="col-12 col-sm-5 col-md-3">
					<div className="index-column">

						<Link className="btn btn-info btn-block mb-2 hidden-mobile" to="/">&lt; Til baka á forsíðu</Link>

						{
							this.props.match.params.ordabok &&
							<CollapsibleCard title={'Uppflettiorð'+(this.props.match.params.ordabok ? (window.ordabankiData && window.ordabankiData.dictionaries ? ': <strong>'+window.ordabankiData.dictionaries[this.props.match.params.ordabok]+'</strong>' : '') : '')} mobileMenu={true} className="gray mb-6 tight-card hidden-mobile">
								<TermIndexList term_id={termsIndexId} startIndex={termsStartIndex} searchParams={this.props.match.params} />
							</CollapsibleCard>
						}
					</div>

					{
						paginationLinks &&
						<div className="index-pagination">
							<div className="pagination">
								{paginationLinks}
							</div>
						</div>
					}

				</div>

				<div className="col-12 col-sm-7 col-md-9">

					<DictionaryInfo ordabok={this.props.match.params.ordabok} />

					<SearchResultsDictionaryOverview searchParams={this.props.match.params} />

					{
						(this.state.listData.length > 0 && this.props.match.params.searchString) &&
						<hr/>
					}


					<SearchResultsLanguageOverview searchParams={this.props.match.params} />

					<div className="list-style-buttons">
						<div className="float-right">
							<ElementNotificationMessage
								placement="under"
								placementOffsetX="-4"
								placementOffsetY="4"
								messageId="list-style-buttons"
								forgetAfterClick={true}
								closeTrigger="click"
								autoHide={true}
								message={'Með þessum tökkum getur þú stjórnað því hvernig listinn birtist þér.'}>
								<button title="Þjappaður listi" className={'btn list-compact'+(!this.state.expandAll ? ' selected' : '')} onClick={function() {
									this.setState({
										expandAll: false
									});
									localStorage.setItem('ordabanki-list-style', '');
								}.bind(this)}></button>
								<button title="Opinn listi" className={'btn list-expanded'+(this.state.expandAll ? ' selected' : '')} onClick={function() {
									this.setState({
										expandAll: true
									});
									localStorage.setItem('ordabanki-list-style', 'expanded');
								}.bind(this)}></button>
							</ElementNotificationMessage>
						</div>

						<div className="clearfix" />
					</div>

					<ul className={'list-group mb-4 dictionary-list'+(this.state.fetching ? ' loading' : '')+(this.state.expandAll ? ' expand-all' : '')}>
						{
							this.state.listData.length > 0 ?
							this.state.listData.map(function(item, index) {
								return <li key={index} className="list-group-item dictionary-entry">
									<TermView order={this.props.match.params.order} data={item} />
								</li>;
							}.bind(this)) : this.state.fetching ?
							<li className="list-group-item text-center">
								Fletti upp í orðasafni
							</li>
							:
							<li className="list-group-item text-center">
								{
									this.props.match.params.ordabok &&
									<React.Fragment>
										<div className="h5 mt-3 mb-4" dangerouslySetInnerHTML={{__html: this.props.match.params.searchString ? 'Leitarorðið "'+this.props.match.params.searchString+'" fannst ekki í orðasafninu <em>'+(window.ordabankiData.dictionaries && window.ordabankiData.dictionaries[this.props.match.params.ordabok] ? window.ordabankiData.dictionaries[this.props.match.params.ordabok] : this.props.match.params.ordabok)+'</em>.' : 'Ekkert fannst'}} />
										{
											this.props.match.params.searchString &&
											<div className="mt-3 mb-4"><Link to={'/leit/'+this.props.match.params.searchString}>Leita að "{this.props.match.params.searchString}" í öllum orðasöfnum</Link></div>
										}
									</React.Fragment>
								}
								{
									!this.props.match.params.ordabok &&
									<React.Fragment>
										<div className="h5 mt-3 mb-4">{this.props.match.params.searchString ? 'Leitarorðið "'+this.props.match.params.searchString+'" skilaði engum niðurstöðum.' : 'Ekkert fannst'}</div>
										<SearchSuggestion searchString={this.props.match.params.searchString} />
									</React.Fragment>
								}
							</li>
						}
					</ul>

				</div>

			</div>
		);
	}
}

export default SearchResultsList;



// WEBPACK FOOTER //
// ./src/components/SearchResultsList.js